import $ from 'jquery';

// Qty in cart
$(document).on('ready', function() {
  
  // Get Modal
  var popup_first_order = $('#popup_first_order');
  if(!popup_first_order)
    return;

  // Continue only if Newsletter Form is not submitted yet
  if(localStorage.getItem('alreadyAlerted') == "true")
    return;

  // Get stored timer orset to 0
  var timer = localStorage.getItem('timer');
  if (!timer)
    timer = 0;

  // Create an interval each second
  var interval = setInterval(function () {

    // Increase & store timer
    timer++;
    localStorage.setItem('timer', timer);

    // After X' of navigation..
    if ( timer >= bauschObject.popup_tempo ) {

      // Launch modal
      document.querySelector('#popup_first_order_trigger').click();

      // Prevent relaunching Modal
      localStorage.setItem('alreadyAlerted', "true");

      // Stop interval
      clearInterval(interval);

    }
  }, 1000); // Each second
});


